import type {
  AccommodationSectionData,
  HeroContent,
  HelpSectionContent,
  ImportantThingItem,
} from "./types";

const getMapUrl = (query: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const getMapEmbedUrl = (query: string) =>
  `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
  
export const heroContent: HeroContent = {
  title: "Accommodation Guides",
  subtitle:
    "Everything you need to know about finding a place to live as a Sudanese student at UTM — from off-campus apartments to on-campus options, agent tips, and community resources",
};

export const offCampusData: AccommodationSectionData = {
  title: "Off-Campus",
  description:
    "Off-campus housing gives you more independence and flexibility in pricing. The options below include popular compounds around Skudai and Johor Bahru that are frequently chosen by UTM students.",
  options: [
    {
      id: "melana-apartment",
      title: "Melana Apartment",
      image: "/images/Accommodation/Melana.jpg",
      about: "",
      priceRange: "RM 300 - RM 800 / person",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Taman Universiti, Skudai, 81300 Johor Bahru",
      mapUrl: getMapUrl("Melana Apartment, Taman Universiti, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Melana Apartment, Taman Universiti, Johor Bahru"),
    },
    {
      id: "melawis-apartment",
      title: "Melawis Apartment",
      image: "/images/Accommodation/Melawis.png",
      about: "",
      priceRange: "RM 300 - RM 800 / person",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Melawis Apartment, Taman Universiti, 81300 Johor Bahru, Johor",
      mapUrl: getMapUrl("Melawis Apartment, Taman Universiti, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Melawis Apartment, Taman Universiti, Johor Bahru"),
    },
    {
      id: "desa-skudai-apartment",
      title: "Desa Skudai Apartment",
      image: "/images/Accommodation/desa.png",
      about: "",
      priceRange: "RM 300 - RM 800 / person",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Desa Skudai Apartment, Near Universiti Teknologi Malaysia",
      mapUrl: getMapUrl("Desa Skudai Apartment, Skudai, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Desa Skudai Apartment, Skudai, Johor Bahru"),
    },
    {
      id: "greenfield-regency",
      title: "Greenfield Regency",
      image: "/images/Accommodation/greenfield.png",
      about: "",
      priceRange: "Price varies by unit and finishing",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Greenfield Regency, Jalan Menteri, 82000 Johor Bahru",
      mapUrl: getMapUrl("Greenfield Regency Service Apartment, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Greenfield Regency Service Apartment, Johor Bahru"),
    },
    {
      id: "the-platino",
      title: "The Platino",
      image: "/images/Accommodation/Platino.png",
      about: "",
      priceRange: "RM 2,000 - RM 3,600",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "The Platino Serviced Apartment, Jalan Menteri, Johor Bahru",
      mapUrl: getMapUrl("The Platino Serviced Apartment, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("The Platino Serviced Apartment, Johor Bahru"),
    },
    {
      id: "kip-park-apartment",
      title: "KIP Park Apartment",
      image: "/images/Accommodation/Kip.png",
      about: "",
      priceRange: "RM 1,000 - RM 2,000 (full unit)",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "KIP Park Apartment, Jalan Menteri, Johor Bahru",
      mapUrl: getMapUrl("KIP Park Apartment, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("KIP Park Apartment, Johor Bahru"),
    },
    {
      id: "pulai-view-apartment",
      title: "Pulai View Apartment",
      image: "/images/Accommodation/PulaiView.png",
      about: "",
      priceRange: "RM 1,500 - RM 2,500",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Pulai View Apartment, Taman Kobena, 81200 Johor Bahru, Johor",
      mapUrl: getMapUrl("Pulai View Apartment, Taman Kobena, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Pulai View Apartment, Taman Kobena, Johor Bahru"),
    },
    {
      id: "the-garden-residences",
      title: "The Garden Residences",
      image: "/images/Accommodation/garden.png",
      about: "",
      priceRange: "RM 800 - RM 2,000",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "The Garden Residences, Taman Pulai Utama, Johor Bahru",
      mapUrl: getMapUrl("The Garden Residences, Taman Pulai Utama, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("The Garden Residences, Taman Pulai Utama, Johor Bahru"),
    },
    {
      id: "d-summit-residence",
      title: "D'Summit Residence",
      image: "/images/Accommodation/Dsummit.png",
      about: "",
      priceRange: "RM 1,500 - RM 2,300",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "D'Summit Residence, Taman Pulai Utama, 81300 Johor Bahru",
      mapUrl: getMapUrl("D'Summit Residence, Taman Pulai Utama, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("D'Summit Residence, Taman Pulai Utama, Johor Bahru"),
    },
    {
      id: "pulai-perdana",
      title: "Pulai Perdana",
      image: "/images/Accommodation/perdana.png",
      about: "",
      priceRange: "RM 1,200 - RM 2,500",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Taman Sri Pulai Perdana, 81300 Johor Bahru, Johor",
      mapUrl: getMapUrl("Taman Sri Pulai Perdana, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Taman Sri Pulai Perdana, Johor Bahru"),
    },
    {
      id: "pulai-springs",
      title: "Pulai Springs",
      image: "/images/Accommodation/spring.png",
      about: "",
      priceRange: "RM 1,800 - RM 3,000",
      priceNote: "",
      pros: [],
      cons: [],
      locationText: "Pulai Springs Resort, Taman Pulai Utama, Johor Bahru",
      mapUrl: getMapUrl("Pulai Springs Resort, Johor Bahru"),
      mapEmbedUrl: getMapEmbedUrl("Pulai Springs Resort, Johor Bahru"),
    },
  ],
};

export const onCampusData: AccommodationSectionData = {
  title: "On-Campus",
  description:
    "On-campus housing is inside UTM residential colleges. It is usually more affordable and closer to classes, but availability for international students can be limited.",
  options: [
    {
      id: "utm-residential-colleges",
      title: "UTM Residential Colleges",
      image: "/images/Accommodation/utm.png",
      about: "",
      priceRange: "Around RM 1,600 / semester",
      priceNote: "",
      pros: [],
      cons: [],
      locationText:
        "Universiti Teknologi Malaysia (UTM) Campus, Skudai, 81310 Johor Bahru",
      mapUrl: getMapUrl("Universiti Teknologi Malaysia, Skudai, Johor"),
      mapEmbedUrl: getMapEmbedUrl("Universiti Teknologi Malaysia, Skudai, Johor"),
    },
  ],
};

export const importantThings: ImportantThingItem[] = [
  {
    id: "dealing-with-agents",
    title: "Dealing with Agents",
    icon: "/icons/Agent.svg",
    points: [
      "Never pay any deposit before physically viewing the unit or verifying it with someone you trust.",
      "Always request an official tenancy agreement signed directly by the landlord.",
      "Avoid agents who ask for a 'booking fee' without providing a receipt.",
      "Check the agent's reviews on Facebook Marketplace or community WhatsApp groups before proceeding.",
      "ISS Sudan maintains a list of verified and trusted agents — reach out to us before signing anything.",
      "Transfer payments via bank transfer and always keep a copy of the receipt.",
    ],
  },
  {
    id: "how-to-find-housing",
    title: "How to Find Housing",
    icon: "/icons/Housing.svg",
    points: [
      "Start searching at least one month before your arrival — especially at the start of semesters.",
      "Ask senior Sudanese students at UTM — they often have available units or know landlord contacts directly.",
      "Walk around areas like Pulai, Skudai, and Impian to spot 'For Rent' signs on buildings.",
    ],
    links: [
      {
        label: "Facebook Marketplace",
        url: "https://www.facebook.com/marketplace",
      },
      {
        label: "mudah.my",
        url: "https://www.mudah.my",
      },
      {
        label: "PropertyGuru Malaysia",
        url: "https://www.propertyguru.com.my",
      },
      {
        label: "iProperty.com.my",
        url: "https://www.iproperty.com.my",
      },
      {
        label: "ISS Sudan WhatsApp Community",
        url: "https://chat.whatsapp.com/",
      },
    ],
  },
  {
    id: "general-tips",
    title: "General Tips",
    icon: "/icons/Tips.svg",
    points: [
      "Sharing a unit with a fellow student is very common — it significantly cuts monthly costs.",
      "Make sure the accommodation is near a bus stop or provides transport to UTM campus.",
      "Carefully read the contract: rental duration, cancellation terms, and included utilities.",
      "Keep a copy of your passport and tenancy agreement stored safely in both physical and digital form.",
      "Avoid paying the full amount in cash — bank transfer gives you a traceable record.",
      "Visit the unit in person before agreeing to anything, and document its condition with photos.",
    ],
  },
];

export const helpSectionContent: HelpSectionContent = {
  title: "Need Help Finding Accommodation?",
  buttonText: "Contact Student Affairs",
  contacts: [
    {
      role: "أمين شؤون الطلاب",
      name: "عزة عارف",
      phone: "0145263758",
      whatsappUrl: "https://wa.me/60145263758",
    },
    {
      role: "نائب أمين شؤون الطلاب",
      name: "أحمد أمير",
      phone: "01162291047",
      whatsappUrl: "https://wa.me/601162291047",
    },
    {
      role: "الأمين العام",
      name: "عبدالله عثمان",
      phone: "01139849594",
      whatsappUrl: "https://wa.me/601139849594",
    },
  ],
};